// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1zkad","col":"styles_col__2AoeF"};